
/** 混入方法 ::: 
 *  @mixin mixRiceIndexCommon 表单编辑页面公共部分混入
 *  @mixin mixFormItemTemplateProtocolRealize 协议实现混入
 *  @mixin mixDomainManager 模块组件管理者混入
 *  @mixin mixFormListManager 表单列表管理者混入
 *  @mixin mixFormNodeManager 表单项节点管理者混入
 *  @mixin mixDomainEditManager 模块组件编辑管理者混入
 *  @mixin mixMakeConfigManager 生成配置管理者混入
 *  @mixin mixFormConfigManager 表单配置管理者混入
 *  @mixin mixEventConfigManager 事件配置管理者混入
 *  @mixin mixFormExhibitsManager 展示表单项管理着混入
 *  @mixin mixEventEditConfigManager 事件编辑管理者混入
 *  @mixin 
 */
import { mixRiceIndexCommon } from "@/mixins/rice_index/mix_rice_index_common.js";
import { mixFormItemTemplateProtocolRealize } from "@/mixins/rice_index/mix_rice_index_protocol_realize.js";
import { mixDomainManager } from "@/mixins/common/mix_domain_manager.js"
import { mixFormListManager } from "@/mixins/common/mix_form_list_manager.js";
import { mixFormNodeManager } from "@/mixins/common/mix_form_node_manager.js";
import { mixDomainEditManager } from "@/mixins/common/mix_domain_edit_manager.js";
import { mixMakeConfigManager } from "@/mixins/common/mix_make_config_manager.js";
import { mixFormConfigManager } from "@/mixins/common/mix_form_config_manager.js";
import { mixEventConfigManager } from "@/mixins/common/mix_event_config_manager.js";
import { mixFormExhibitsManager } from "@/mixins/common/mix_form_exhibits_manager.js";
import { mixEventEditConfigManager } from "@/mixins/common/mix_event_edit_config_manager.js";

/** @name RiceIndex 子级组件混入
 *  @author 王汝鹏
 *  @version 2019-11-24
 */
export const mixRiceIndexChild = {
  inject: ['mix_rice_index_store'],
  mixins: [ 
    mixRiceIndexCommon,
    mixDomainManager,
    mixFormListManager,
    mixFormNodeManager,
    mixMakeConfigManager,
    mixDomainEditManager,
    mixFormConfigManager,
    mixEventConfigManager,
    mixFormExhibitsManager,
    mixEventEditConfigManager,
    mixFormItemTemplateProtocolRealize 
  ],
}



// WEBPACK FOOTER //
// ./src/mixins/rice_index/mix_rice_index_child.js